// extracted by mini-css-extract-plugin
export default {"socialProofTitle":"LoNRLK","mobile":"z4LiB0"};